import { SYNC_CHECK_CONSTANT } from "./SyncCheckConstant.ts";
import { differenceInCalendarMonths } from "date-fns";

interface SyncCheckInterface {
    result: string;
    year: number;
    month: number;
    room_id: number;
    room_name: string | null;
    created_at: Date;
    status: string;
}

class SyncCheck implements SyncCheckInterface {
    result: string;
    year: number;
    month: number;
    room_id: number;
    room_name: string | null;
    created_at: Date;
    status: string;

    constructor(result: string, year: number, month: number, room_id: number, room_name: string | null, created_at: Date, status: string) {
        this.result = result;
        this.year = year;
        this.month = month;
        this.room_id = room_id;
        this.room_name = room_name || null;
        this.created_at = created_at;
        this.status = status;
    }

    getStatus(): string {
        if (this.status === SYNC_CHECK_CONSTANT.RESULT_OK) {
            return "正常";
        } else if (this.status === SYNC_CHECK_CONSTANT.RESULT_NG) {
            return "エラー有";
        } else if (this.status === SYNC_CHECK_CONSTANT.RESULT_ERROR) {
            return "チェックエラー";
        } else {
            return "不明";
        }
    }
    getDiffInMonth(): number {
        const target_date: Date = new Date(this.year, this.month - 1, 1);
        return differenceInCalendarMonths(target_date, new Date());
    }
    getErrorDays(): Array<Date> {
        if (this.result) {
            const results = this.result.split(",");
            return results
                .map((result, index) => {
                    if (result === "0") {
                        return null;
                    }
                    const date = new Date(this.year, this.month - 1, index + 1);
                    return date;
                })
                .filter((date) => date !== null) as Array<Date>;
        } else {
            return [];
        }
    }
}

export default SyncCheck;
